import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Capacitor } from "@capacitor/core";
import { ServiceProCookieConsentButtonComponent } from "../../cookie-consent/service-pro-cookie-consent-button.component";
import { webVersion } from "./web-version";

export interface UserInfoData {
    user: {
        initialer?: string;
        name: string;
        email: string;
        phone: string;
    };
    works: {
        name: string;
        address: string;
        phone: string;
    };
}

@Component({
    selector: "user-info",
    imports: [CommonModule, ServiceProCookieConsentButtonComponent],
    templateUrl: "./user-info.html",
    styleUrl: "./user-info.scss"
})
export class UserInfo {
    @Input()
    public data: UserInfoData;
    @Output()
    public close = new EventEmitter<void>();

    public readonly webVersion = webVersion;
    public readonly klientLabel = Capacitor.isNativePlatform() ? "app" : "browser";

    public onClose(): void {
        this.close.emit();
    }
}
